<template>
  <div>
    <div class="search_area mt-4">
      <v-row cols="12" class="ma-0">
        <v-col cols="12" class="pl-0 pb-0">
          <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="search_from_date"
                readonly
                v-on="on"
                dense
                :style="{ height: '80%' }"
                class="d-inline-block mr-1 date-input"
              ></v-text-field>
            </template>
            <v-date-picker v-model="search_from_date" @input="startMenu = false" locale="ko" :max="search_to_date"></v-date-picker> </v-menu
          >~
          <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="search_to_date"
                readonly
                v-on="on"
                dense
                :style="{ height: '80%' }"
                class="d-inline-block mr-1 date-input"
              ></v-text-field>
            </template>
            <v-date-picker v-model="search_to_date" @input="endMenu = false" locale="ko" :min="search_from_date"></v-date-picker>
          </v-menu>
          <v-btn dark class="ml-3" large @click="getMinusPointList">조회</v-btn>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row>
        <v-col class="pt-0">
          <v-card outlined>
            <v-data-table
              :headers="headers"
              :items="minusPointList"
              :server-items-length="send_list_total"
              :loading="tableLoading"
              :items-per-page="searchPayload.limit"
              hide-default-footer
              class="pa-2 elevation-1"
            >
              <template v-slot:[`item.remain_points`]="{ item }">
                <div>{{ item.remain_points | numberFormat }}</div>
              </template>
              <template v-slot:[`item.send_points`]="{ item }">
                <div>{{ item.send_points | numberFormat }}</div>
              </template>
              <template v-slot:[`item.send_type_text`]="{ item }">
                <div v-html="item.send_type_text"></div>
              </template>
              <template slot="no-data">
                <div class="noDataProductInfos">내역이 없습니다.</div>
              </template>
            </v-data-table>
          </v-card>
          <template>
            <div class="text-xs-center mt-7">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
          </template>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped>
.date-input {
  width: 120px;
}
</style>

<script>
import M from "@/libs/mapping.js";
import Filters from "@/libs/authservice/filters.js";
export default {
  data() {
    return {
      search_to_date: null,
      search_from_date: null,
      startMenu: false,
      endMenu: false,
      minusPointList: [],
      send_list_total: 0,
      headers: [
        {
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          width: "50px",
        },
        {
          text: "소진일시",
          align: "center",
          sortable: false,
          value: "send_date",
          width: "180px",
        },
        {
          text: "발송타입",
          align: "center",
          sortable: false,
          value: "send_type_text",
          width: "300px",
        },
        {
          text: "메시지",
          align: "center",
          sortable: false,
          value: "content",
        },
        {
          text: "소진 포인트",
          align: "center",
          sortable: false,
          value: "send_points",
          width: "100px",
        },
        {
          text: "남은 포인트",
          align: "center",
          sortable: false,
          value: "remain_points",
          width: "100px",
        },
      ],
      page: 1,
      pageCount: 0,
      tableLoading: false,
      searchPayload: {
        limit: 20,
        offset: 0,
      },
    };
  },
  created() {
    let date = new Date();
    date.setMonth(date.getMonth() - 1);
    this.search_from_date = date.toISOString().substr(0, 10);
    this.search_to_date = new Date().toISOString().substr(0, 10);
    this.getMinusPointList();
  },
  watch: {
    page: {
      handler() {
        this.getMinusPointList();
      },
      deep: true,
    },
    send_list_total: function() {
      this.pageCount = Math.ceil(this.send_list_total / this.searchPayload.limit);
    },
  },
  methods: {
    getMinusPointList: async function() {
      const payload = {
        from: this.search_from_date,
        to: this.search_to_date,
        limit: this.searchPayload.limit,
        offset: (this.page - 1) * this.searchPayload.limit,
      };
      try {
        this.minusPointList = [];
        this.tableLoading = true;
        const res = await M.api(M.entry("/get/message/point_history"), payload);
        this.send_list_total = res.count;
        let current_points = 0;
        res.list.forEach((item, index) => {
          item.no = this.send_list_total - (this.page - 1) * this.searchPayload.limit - index;
          this.minusPointList.push(this.convertListData(item));
          if (this.page === 1 && index === 0) {
            current_points = item.remain_points;
          }
        });

        // API 응답에 현재 포인트 정보가 포함되어 있다면 AppVersion에 반영
        if (this.page === 1) {
          this.$store.commit("UPDATE_POINT", current_points);
          console.log(`💰 포인트 업데이트: ${current_points}P`);
        }
        this.tableLoading = false;
      } catch (error) {
        console.error(error);
        this.tableLoading = false;
      }
    },
    convertListData: function(data) {
      data.content = this.$options.filters.msgTypeText(data.send_content).replace(/<br\/>/g, " ");
      data.send_type_text = this.$options.filters.sendTypeText(data.send_type).replace(/\(/g, "<br/>(");
      if (data.send_status === "success") {
        data.result = 1;
        data.result_success = 1;
        data.result_fail = 0;
      } else {
        data.result = 1;
        data.result_success = 0;
        data.result_fail = 1;
      }
      return data;
    },
  },
  filters: Filters,
};
</script>
